import httpRequest from "@/auth/http-client";
import { ISubscribe, ISubscribeInput } from "@/interfaces/subscribe.interfaces";

class SubscriptionService {
  private baseUrl = "api/v1/subscribe";

  async createSubscription(subscriptionData: ISubscribeInput): Promise<ISubscribe> {
    return await httpRequest.post(this.baseUrl, subscriptionData);
  }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;
